export const array = {
  empty<T>(): T[] {
    return [];
  },

  sequence(count: number) {
    return Array.from(new Array(count)).map((_, index) => index);
  },
};
